import MainReport from "module/report/mainReport";
import BasicIndex from "module/report/basicIndex";
import Dashboard from "module/dashboard/index"
import SquareOfSolidarity from 'module/squareOfSolidarity/index'
import Comparison from 'module/Comparison/index'
import AboutSurvey from "views/AboutSurvey";
import Login from "../views/Login";
import Index from "../views";
import Faq from "../views/Faq";


var routes = [
  {
    path: "/admin/reports/main",
    name: "آسیب های اجتماعی",
    rtlName: "آسیب های اجتماعی",
    icon: "tim-icons icon-chart-pie-36",
    component: MainReport,
    exact: true,
    public:false

  },
  {
    path: "/admin/Square-of-solidarity",
    name: "تعیین کننده ها",
    rtlName: "تعیین کننده ها",
    icon: "tim-icons icon-sound-wave",
    component: SquareOfSolidarity,
    exact: true,
    public:false

  },
  {
    path: "/admin/report/basic",
    name: "شاخص های پایه",
    rtlName: "شاخص های پایه",
    icon: "tim-icons icon-settings",
    component: BasicIndex,
    exact: true,
    public:false

  }, {
    path: "/admin/comparison",
    name: "مقایسه",
    rtlName: "مقایسه",
    icon: "tim-icons icon-settings",
    component: Comparison,
    exact: true,
    public:false,
  },
  {
    path: "/admin/setting",
    name: "تنظیمات",
    rtlName: "تنظیمات",
    icon: "tim-icons icon-settings",
    component: "",
    exact: true,
    public:false

  },
  {
    path: "/admin/about",
    name: "اطلاعات تکمیلی",
    rtlName: "اطلاعات تکمیلی",
    icon: "tim-icons icon-bulb-63",
    component: AboutSurvey,
    exact: true,
    public:false

  },
  {
    path: "/admin/dashboard",
    name: "داشبورد",
    rtlName: "داشبورد",
    icon: "tim-icons icon-settings",
    component: Dashboard,
    exact: true,
    redirect:true,
    public:false

  },
  {
    path: "/login",
    name: "ورود",
    rtlName: "ورود",
    icon: "tim-icons icon-settings",
    component:Login,
    exact: true,
    redirect:true,
    public:true
  },
  {
    path: "/",
    name: "صفحه اصلی",
    rtlName: "صفحه اصلی",
    icon: "tim-icons icon-settings",
    component:Index,
    exact: true,
    redirect:true,
    public:true
  },{
    path: "/faq",
    name: "قوانین و مقررات",
    rtlName: "قوانین و مقررات",
    icon: "tim-icons icon-settings",
    component:Faq,
    exact: true,
    redirect:true,
    public:true
  },


];
export default routes;
